import * as React from 'react';
import { usePopStateInterceptor } from '../../../utils/hooks/use-pop-state-interceptor.ts';
import { TextIconButton } from '../button/button.tsx';

export type BackButtonProps = {
  goBack: () => void;
  text?: string;
  className?: string;
};

/**
 * We use the same visual back button in many places.
 */
export const BackButton: React.FunctionComponent<BackButtonProps> = props => {
  const { text = 'Zurück', className, goBack } = props;

  usePopStateInterceptor({
    popStateCancelled: goBack,
    shouldPopStateCancel: () => true
  });

  return (
    <TextIconButton className={className} iconName="arrow-left" onClick={goBack}>
      {text}
    </TextIconButton>
  );
};
